// extracted by mini-css-extract-plugin
export default {"container":"Label_container__SEqa8","labelContainer":"Label_labelContainer__AW677","error":"Label_error__lP0Nk","toolTipAlign":"Label_toolTipAlign__HRc+i"};